import { Audio, Images } from "@abcya/abcya_phaser";
import { centerSprite, enableUserClick } from "../phaserHelpers";
import SoundAssetKeys from "../SoundAssetKeys";
import UIAssetKeys from "../UIAssetKeys";

export default class PauseDialog extends Phaser.GameObjects.Container
{
	constructor(scene, game, atlasId, clickCallback)
	{
        super(scene)
        this.atlasId = atlasId;
        this.clickCallback = clickCallback;

        //var bmd = this.backdrop = this.game.add.bitmapData(this.scene.scale.width, this.scene.scale.height);
        // bmd.ctx.fillStyle = 'black';
        // bmd.ctx.fillRect(0,0, this.scene.scale.width, this.scene.scale.height);
        const bmd = this.bd = this.scene.add.rectangle(0, 0, this.scene.scale.width, this.scene.scale.height, 0x000000, .8).setOrigin(0);
        this.add(bmd);

        // this.flashOverlay = this.create(0, 0, bmd, this);
        //this.bmd.alpha = 0.8;

        this.bg = Images.addImage(0, 0, UIAssetKeys._Paused_Bg, this).setOrigin(0);
        this.bg.x = this.scene.scale.width/2-this.bg.width/2;
        this.bg.y = this.scene.scale.height/2-this.bg.height/2;

        let itype = "Mobile";
        if (this.scene.game.device.desktop) {
            itype = "Desktop";
        }
        this.instruct = Images.addImage(this.bg.x+this.bg.width/2,this.bg.y+this.bg.height*0.72, UIAssetKeys._Paused_Desktop, this);
        centerSprite(this.instruct);

        const btny = this.scene.scale.height-(this.scene.scale.height - this.bg.y+this.bg.height)/2;
        this.btnMenu = Images.addImage(0, 0, UIAssetKeys._Paused_MenuButton, this).setOrigin(0);
        this.btnMenu.x = this.bg.x;
        this.btnMenu.y = btny;
        this.btnPlay = Images.addImage(0, 0, UIAssetKeys._BUTTON_Play, this).setOrigin(0);
        this.btnPlay.x = this.bg.x+this.bg.width-this.btnPlay.width;
        this.btnPlay.y = btny;

        enableUserClick(this.btnMenu, ()=>this.onClickButton(this.btnMenu), this);
        enableUserClick(this.btnPlay, this.onClickButton, this);
    }

    onClickButton(sprite, pointer) {
        Audio.playOneShot(SoundAssetKeys._click_Copy, this.scene);
        if (sprite === this.btnMenu) {
            this.clickCallback("menu");
        }else{
            this.clickCallback();
        }
    };
}